import { type Location } from 'src/types'

export const locations: Location[] = [
  {
    dayLightGrid: [
      [
        4,
        4,
        4,
        4,
        4
      ],
      [
        4,
        3,
        3,
        3,
        4
      ],
      [
        3,
        3,
        3,
        3,
        4
      ],
      [
        4,
        3,
        3,
        3,
        4
      ],
      [
        4,
        4,
        4,
        4,
        4
      ]
    ],
    events: [
      {
        ui: '←',
        color: 'gold',
        x: 0,
        player_y: 2,
        y: 2,
        player_x: 5,
        id: 'club',
        type: 'travel'
      },
      {
        ui: 'B',
        color: 'gold',
        spriteID: 'baltu',
        x: 3,
        y: 2,
        id: 'baltu_introduced',
        type: 'event'
      }
    ],
    width: 5,
    height: 5,
    contentGrid: [
      [
        '╔',
        '═',
        '═',
        '═',
        '╗'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '╚',
        '═',
        '═',
        '═',
        '╝'
      ]
    ],
    createdAt: 1686432573788,
    nightLightGrid: [
      [
        4,
        4,
        4,
        4,
        4
      ],
      [
        4,
        3,
        3,
        3,
        4
      ],
      [
        3,
        3,
        3,
        3,
        4
      ],
      [
        4,
        3,
        3,
        3,
        4
      ],
      [
        4,
        4,
        4,
        4,
        4
      ]
    ],
    id: 'club_back_room',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        3,
        3,
        3,
        3,
        3
      ],
      [
        3,
        2,
        2,
        2,
        3
      ],
      [
        3,
        2,
        2,
        2,
        2
      ],
      [
        3,
        2,
        2,
        2,
        3
      ],
      [
        3,
        3,
        3,
        3,
        3
      ]
    ],
    events: [
      {
        ui: 'S',
        color: 'gold',
        x: 1,
        y: 1,
        id: 'walter_stash',
        type: 'stash'
      },
      {
        ui: 'B',
        color: 'gold',
        x: 3,
        y: 3,
        id: 'bed_rest',
        type: 'event'
      },
      {
        ui: 'W',
        color: 'gold',
        spriteID: 'walter',
        x: 3,
        y: 1,
        id: 'walter_bridge',
        type: 'event'
      },
      {
        ui: '→',
        color: 'gold',
        x: 4,
        player_y: 7,
        y: 2,
        player_x: 0,
        id: 'tunnel',
        type: 'travel'
      }
    ],
    width: 5,
    height: 5,
    contentGrid: [
      [
        '╔',
        '═',
        '═',
        '═',
        '╗'
      ],
      [
        '║',
        'S',
        '.',
        'W',
        '║'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '║',
        '.',
        '.',
        'B',
        '║'
      ],
      [
        '╚',
        '═',
        '═',
        '═',
        '╝'
      ]
    ],
    createdAt: Date.now(),
    nightLightGrid: [
      [
        3,
        3,
        3,
        3,
        3
      ],
      [
        3,
        2,
        2,
        2,
        3
      ],
      [
        3,
        2,
        2,
        2,
        2
      ],
      [
        3,
        2,
        2,
        2,
        3
      ],
      [
        3,
        3,
        3,
        3,
        3
      ]
    ],
    id: 'walter_home',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4
      ],
      [
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4
      ],
      [
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4
      ]
    ],
    events: [
      {
        ui: '←',
        color: 'gold',
        x: 0,
        player_y: 8,
        y: 2,
        player_x: 9,
        id: 'streets',
        type: 'travel'
      },
      {
        ui: '→',
        color: 'gold',
        x: 7,
        player_y: 2,
        y: 2,
        player_x: 0,
        id: 'club_back_room',
        type: 'travel'
      },
      {
        ui: 'B',
        color: 'gold',
        spriteID: 'fletcher',
        x: 6,
        y: 1,
        id: 'baltu_intro',
        type: 'event'
      }
    ],
    width: 8,
    height: 6,
    contentGrid: [
      [
        '╔',
        '═',
        '═',
        '═',
        '═',
        '═',
        '═',
        '╗'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '╚',
        '═',
        '═',
        '═',
        '═',
        '═',
        '═',
        '╝'
      ]
    ],
    createdAt: 1686432506211,
    nightLightGrid: [
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4
      ],
      [
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4
      ],
      [
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4
      ]
    ],
    id: 'club',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    ],
    events: [
      {
        ui: '↓',
        color: 'gold',
        x: 9,
        player_y: 0,
        y: 20,
        player_x: 5,
        id: 'wilderness',
        type: 'travel'
      },
      {
        x: 5,
        y: 10,
        id: 'desert_graveyard',
        ui: '†',
        type: 'event',
        color: 'black'
      },
      {
        x: 4,
        y: 11,
        id: 'desert_graveyard',
        ui: '†',
        type: 'event',
        color: 'black'
      },
      {
        x: 6,
        y: 11,
        id: 'desert_graveyard',
        ui: '†',
        type: 'event',
        color: 'black'
      },
      {
        x: 5,
        y: 12,
        id: 'desert_graveyard',
        ui: '†',
        type: 'event',
        color: 'black'
      },
      {
        x: 9,
        y: 1,
        id: 'lab_default',
        ui: 'L',
        type: 'event',
        color: 'gold'
      },
      {
        ui: 'W',
        color: 'gold',
        spriteID: 'lumberjack_relaxed',
        x: 12,
        y: 5,
        id: 'vanya',
        type: 'event'
      },
      {
        ui: 'Y',
        color: 'gold',
        spriteID: 'yogi',
        x: 15,
        y: 10,
        id: 'yogi_default',
        type: 'event'
      },
      {
        ui: 'W',
        color: 'firebrick',
        spriteID: 'wanderer',
        x: 13,
        y: 4,
        id: 'wanderer_lvl_20',
        type: 'fight'
      },
      {
        ui: 'C',
        color: 'firebrick',
        spriteID: 'dog',
        x: 7,
        pattern: 'loop',
        y: 15,
        id: 'coyotes_lvl_12',
        type: 'fight',
        steps: [
          {
            x: 7,
            y: 13
          },
          {
            x: 7,
            y: 18
          }
        ]
      },
      {
        ui: 'C',
        color: 'firebrick',
        spriteID: 'dog',
        x: 9,
        pattern: 'loop',
        y: 10,
        id: 'coyotes_lvl_12',
        type: 'fight',
        steps: [
          {
            x: 7,
            y: 15
          },
          {
            x: 9,
            y: 10
          }
        ]
      },
      {
        ui: 'C',
        color: 'firebrick',
        spriteID: 'dog',
        x: 5,
        pattern: 'loop',
        y: 15,
        id: 'coyotes_lvl_12',
        type: 'fight',
        steps: [
          {
            x: 2,
            y: 10
          },
          {
            x: 5,
            y: 15
          }
        ]
      }
    ],
    width: 20,
    height: 20,
    contentGrid: [
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ',',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        ',',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ',',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ',',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ]
    ],
    createdAt: 1686432588492,
    nightLightGrid: [
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ]
    ],
    id: 'desert',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ]
    ],
    events: [
      {
        x: 0,
        y: 0,
        id: 'hut_rest',
        ui: '⌂',
        type: 'event'
      }
    ],
    width: 16,
    height: 16,
    contentGrid: [
      [
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'N',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ'
      ],
      [
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        '.',
        '.',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ',
        'φ'
      ],
      [
        'φ',
        'φ',
        'φ',
        '.',
        'φ',
        '.',
        '.',
        '.',
        '.',
        '.',
        'φ',
        '.',
        'φ',
        'φ',
        'φ',
        'φ'
      ],
      [
        'φ',
        'φ',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        'φ',
        'φ'
      ],
      [
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        'A',
        ' ',
        'A',
        ' ',
        'A',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.'
      ],
      [
        ' ',
        ',',
        ',',
        ' ',
        ' ',
        'A',
        ' ',
        'V',
        ' ',
        'A',
        ' ',
        ' ',
        ',',
        ',',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ',',
        ',',
        ' ',
        ' ',
        'A',
        ' ',
        'A',
        ' ',
        ' ',
        ' ',
        ',',
        ',',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ',',
        ','
      ],
      [
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#'
      ],
      [
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#'
      ],
      [
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '∩',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#',
        '#'
      ],
      [
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈'
      ],
      [
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈'
      ],
      [
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈'
      ],
      [
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈',
        '≈'
      ]
    ],
    createdAt: 1686432674361,
    nightLightGrid: [
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ]
    ],
    id: 'village',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        0
      ],
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ]
    ],
    events: [
      {
        ui: 'N',
        color: 'gold',
        spriteID: 'nuno',
        x: 0,
        y: 2,
        id: 'demo_intro',
        type: 'event'
      },
      {
        ui: 'W',
        color: 'gold',
        spriteID: 'junker',
        x: 12,
        y: 4,
        id: 'junker_intro',
        type: 'event'
      },
      {
        ui: '↑',
        color: 'gold',
        x: 7,
        player_y: 8,
        y: 0,
        player_x: 5,
        id: 'wilderness',
        type: 'travel'
      },
      {
        ui: '←',
        color: 'gold',
        x: 0,
        player_y: 2,
        y: 7,
        player_x: 4,
        id: 'walter_home',
        type: 'travel'
      },
      {
        ui: '↓',
        color: 'gold',
        x: 7,
        player_y: 0,
        y: 11,
        player_x: 7,
        id: 'streets',
        type: 'travel'
      },
      {
        ui: '→',
        color: 'gold',
        x: 13,
        player_y: 1,
        y: 10,
        player_x: 0,
        id: 'east_tunnel',
        type: 'travel'
      },
      {
        ui: 't',
        color: 'gold',
        spriteID: 'turtle_boy',
        x: 3,
        y: 1,
        id: 'turtle_boy_encounter',
        type: 'event'
      }
    ],
    width: 14,
    height: 12,
    contentGrid: [
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '╥',
        '╥',
        '.',
        '╥',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        '╧',
        '╧',
        '.',
        '╧',
        ' ',
        ' ',
        ' ',
        ' ',
        ' '
      ]
    ],
    createdAt: 1686465570964,
    nightLightGrid: [
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        0
      ],
      [
        5,
        5,
        5,
        3,
        3,
        2,
        2,
        2,
        2,
        3,
        3,
        5,
        5,
        5
      ]
    ],
    id: 'tunnel',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ]
    ],
    events: [
      {
        ui: '←',
        color: 'gold',
        x: 0,
        player_y: 10,
        y: 1,
        player_x: 13,
        id: 'tunnel',
        type: 'travel'
      },
      {
        ui: '¤',
        color: 'gold',
        x: 7,
        y: 1,
        id: 'tunnel_manhole',
        player_x: 7,
        player_y: 1,
        type: 'travel'
      },
      {
        x: 6,
        y: 1,
        id: 'tortoise_lvl_8',
        ui: 't',
        type: 'fight',
        spriteID: 'tortoise'
      }
    ],
    width: 8,
    height: 6,
    contentGrid: [
      [
        '╥',
        '╥',
        '╥',
        '╥',
        '╥',
        '╥',
        '╥',
        '╥'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      
      [
        '╥',
        '╥',
        '╥',
        '╥',
        '╥',
        '╥',
        '╥',
        '╥'
      ]
    ],
    createdAt: 1686433054374,
    nightLightGrid: [
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ]
    ],
    id: 'east_tunnel',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    ],
    events: [
      {
        ui: '↑',
        color: 'gold',
        x: 5,
        player_y: 20,
        y: 0,
        player_x: 9,
        id: 'desert',
        type: 'travel'
      },
      {
        ui: '↓',
        color: 'gold',
        x: 5,
        player_y: 0,
        y: 8,
        player_x: 7,
        id: 'tunnel',
        type: 'travel'
      },
      {
        ui: 'Ö',
        color: 'firebrick',
        spriteID: 'bear',
        x: 1,
        y: 0,
        id: 'bear_lvl_9',
        type: 'fight'
      },
      {
        ui: 'ô',
        color: 'firebrick',
        spriteID: 'wolf',
        x: 7,
        pattern: 'loop',
        y: 5,
        id: 'wolf_lvl_1',
        type: 'fight',
        steps: [
          {
            x: 5,
            y: 2
          },
          {
            x: 7,
            y: 5
          }
        ]
      }
    ],
    width: 10,
    height: 9,
    contentGrid: [
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ',',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        ',',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        ',',
        '.',
        '.'
      ],
      [
        '.',
        '.',
        ',',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ]
    ],
    createdAt: 1686432683139,
    nightLightGrid: [
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      [
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ]
    ],
    id: 'wilderness',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        0,
        3,
        3,
        3,
        3,
        3,
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        1
      ],
      [
        0,
        3,
        3,
        3,
        3,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        0,
        3,
        3,
        3,
        3,
        3,
        0,
        0,
        0,
        3,
        3,
        3,
        3,
        3,
        0
      ],
      [
        0,
        3,
        3,
        3,
        3,
        0,
        0,
        0,
        0,
        3,
        3,
        3,
        3,
        3,
        0
      ],
      [
        0,
        3,
        3,
        3,
        3,
        3,
        0,
        0,
        0,
        0,
        3,
        3,
        3,
        3,
        0
      ],
      [
        0,
        3,
        3,
        3,
        3,
        3,
        0,
        0,
        0,
        3,
        3,
        3,
        3,
        3,
        0
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        3,
        3,
        3,
        3,
        0
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        3,
        3,
        3,
        3,
        3,
        0
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]
    ],
    events: [
      {
        ui: '↑',
        color: 'gold',
        x: 7,
        player_y: 11,
        y: 0,
        player_x: 7,
        id: 'tunnel',
        type: 'travel'
      },
      {
        ui: 'T',
        color: 'firebrick',
        spriteID: 'thug',
        x: 0,
        pattern: 'loop',
        y: 4,
        id: 'thug_lvl_7',
        type: 'fight',
        steps: [
          {
            x: 0,
            y: 9
          },
          {
            x: 0,
            y: 4
          }
        ]
      },
      {
        ui: 'S',
        color: 'gold',
        spriteID: 'shopkeeper',
        x: 5,
        y: 7,
        id: 'streets_shop',
        type: 'event'
      },
      {
        ui: 'F',
        color: 'gold',
        spriteID: 'fletcher',
        x: 8,
        y: 8,
        id: 'fletcher_intro',
        type: 'event'
      },
      {
        ui: '→',
        color: 'gold',
        x: 9,
        player_y: 2,
        y: 8,
        player_x: 0,
        id: 'club',
        type: 'travel'
      }
    ],
    width: 15,
    height: 15,
    contentGrid: [
      [
        '═',
        '═',
        '═',
        '╝',
        '¦',
        '╟',
        '╥',
        '.',
        '║',
        '¦',
        '║',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '-',
        '-',
        '-',
        '-',
        '┘',
        '║',
        '.',
        '.',
        '║',
        '¦',
        '║',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '╤',
        '═',
        '╤',
        '═',
        '╤',
        '╝',
        '.',
        '.',
        '║',
        '¦',
        '╚',
        '═',
        '═',
        '═',
        '═'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '║',
        '└',
        '-',
        '-',
        '-',
        '-',
        '-'
      ],
      [
        '.',
        '╔',
        '═',
        '═',
        '═',
        '╗',
        '.',
        '.',
        '╚',
        '╤',
        '═',
        '╤',
        '═',
        '╤',
        '═'
      ],
      [
        '.',
        '║',
        ' ',
        's',
        ' ',
        '║',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '.',
        '║',
        ' ',
        'h',
        ' ',
        '║',
        '.',
        '.',
        '.',
        '╔',
        '═',
        '═',
        '═',
        '╗',
        '.'
      ],
      [
        '.',
        '║',
        ' ',
        'o',
        ' ',
        '.',
        '.',
        '.',
        '.',
        '║',
        ' ',
        'c',
        ' ',
        '║',
        '.'
      ],
      [
        '.',
        '║',
        ' ',
        'p',
        ' ',
        '║',
        '.',
        '.',
        '.',
        '.',
        ' ',
        'l',
        ' ',
        '║',
        '.'
      ],
      [
        '.',
        '╚',
        '═',
        '═',
        '═',
        '╝',
        '.',
        '.',
        '.',
        '║',
        ' ',
        'u',
        ' ',
        '║',
        '.'
      ],
      [
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '║',
        ' ',
        'b',
        ' ',
        '║',
        '.'
      ],
      [
        '═',
        '═',
        '═',
        '═',
        '═',
        '═',
        '╗',
        '.',
        '.',
        '╚',
        '═',
        '═',
        '═',
        '╝',
        '.'
      ],
      [
        '-',
        '-',
        '-',
        '-',
        '-',
        '┐',
        '║',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ],
      [
        '╤',
        '═',
        '╤',
        '═',
        '╗',
        '¦',
        '║',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.',
        '.'
      ]
    ],
    createdAt: 1686432657321,
    nightLightGrid: [
      [
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        4,
        4,
        4,
        3,
        3,
        3,
        3
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        4,
        4,
        4,
        3,
        3,
        3,
        3
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        4,
        4
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        4,
        4
      ],
      [
        3,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        4,
        4
      ],
      [
        3,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        3,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        3
      ],
      [
        3,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        3
      ],
      [
        3,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        3
      ],
      [
        3,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        3
      ],
      [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        3
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        4,
        4,
        4,
        4,
        4,
        3
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      [
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ]
    ],
    id: 'streets',
    isVerified: false
  },
  {
    dayLightGrid: [
      [
        2,
        2,
        2,
        2,
        2
      ],
      [
        2,
        0,
        0,
        0,
        2
      ],
      [
        2,
        0,
        0,
        0,
        2
      ],
      [
        2,
        0,
        0,
        0,
        2
      ],
      [
        2,
        2,
        0,
        2,
        2
      ]
    ],
    events: [],
    width: 5,
    height: 5,
    contentGrid: [
      [
        '╔',
        '═',
        '═',
        '═',
        '╗'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '║',
        '.',
        '◯',
        '.',
        '║'
      ],
      [
        '║',
        '.',
        '.',
        '.',
        '║'
      ],
      [
        '╚',
        '═',
        '.',
        '═',
        '╝'
      ]
    ],
    createdAt: 1686432644098,
    nightLightGrid: [
      [
        2,
        2,
        2,
        2,
        2
      ],
      [
        2,
        0,
        0,
        0,
        2
      ],
      [
        2,
        0,
        0,
        0,
        2
      ],
      [
        2,
        0,
        0,
        0,
        2
      ],
      [
        2,
        2,
        0,
        2,
        2
      ]
    ],
    id: 'room',
    isVerified: false
  }
]

// Export removed - now using named export above
